export default __webpack_public_path__ + "static/media/head04_en_pc@2x.d0865dde.png";